import { Link, useLocation } from 'react-router-dom';
import { allCategories } from '@/mocks/categoryData';

const nameMap: Record<string, string> = {
  category: '分类',
  resources: '豪门资源',
  business: '商务合作',
  social: '精英社交',
  investment: '国际投资',
  education: '精英教育',
  lifestyle: '品质生活',
  about: '关于我们',
  article: '文章详情',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs = [{ label: '首页', href: '/' }];

  pathSegments.forEach((segment, index) => {
    const isLast = index === pathSegments.length - 1;
    let label = nameMap[segment] || segment;

    if (index === 0 && segment === 'category' && pathSegments[1]) {
      label = '分类';
    }
    if (index === 1 && pathSegments[0] === 'category') {
      const cat = allCategories.find(c => c.slug === segment);
      label = cat ? cat.name : segment;
    }

    const href = '/' + pathSegments.slice(0, index + 1).join('/');
    breadcrumbs.push({ label, href });
  });

  return (
    <nav aria-label="面包屑导航" className="bg-background-50 border-b border-background-200/60">
      <div className="container-custom py-3">
        <ol className="flex items-center flex-wrap text-xs text-foreground-500">
          {breadcrumbs.map((crumb, i) => (
            <li key={crumb.href} className="flex items-center">
              {i > 0 && (
                <span className="mx-2 text-foreground-400">/</span>
              )}
              {i < breadcrumbs.length - 1 ? (
                <Link
                  to={crumb.href}
                  className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((crumb, i) => ({
              '@type': 'ListItem',
              position: i + 1,
              name: crumb.label,
              item: `${window.location.origin}${crumb.href}`,
            })),
          }),
        }}
      />
    </nav>
  );
}